import type { ReactNode } from 'react';

export const symbol_video_chat: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M313-409h247q14.03 0 23.51-9.77Q593-428.55 593-443v-93l74 74q4 4 8.5 2.12 4.5-1.87 4.5-7.12v-191q0-5.25-4.5-7.13Q671-667 667-663l-74 74v-94q0-14.03-9.49-23.51Q574.03-716 560-716H313q-14.02 0-23.51 9.49Q280-697.03 280-683v240q0 14.45 9.49 24.23Q298.98-409 313-409Zm-73 169L131-131q-14 14-32.5 6.34Q80-132.31 80-152v-668q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H240Zm-26-60h606v-520H140v600l74-80Zm-74 0v-520 520Z"
		/>
	</svg>
);
